import React from 'react'
import { makeStyles, MenuItem, Select } from '@material-ui/core'

import Button from '../button/Button'
import Modal from '../modal/Modal'
import { occupationsObject } from '../../utils/dicts'
import previewSVG from '../../assets/icons/preview-eye.svg'
import StyledSVG from '../shared/StyledSVG'
import FormProgress from '../shared/FormProgress'
import MobilePreview from '../shared/MobilePreview'
import { Field } from 'redux-form'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import Grid from '@material-ui/core/Grid'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import MenuBookTwoToneIcon from '@material-ui/icons/MenuBookTwoTone'
import frame from '../../assets/icons/Frame.svg'
import seethemes from '../../assets/icons/seethemes.svg'
import FileAudio from '../../assets/icons/file-audio.svg'
import FileFolder from '../../assets/icons/file-folder.svg'
import FileVideo from '../../assets/icons/file-video.svg'

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      columnGap: 12
    },
    '& path': {
      stroke: '#4D5E80'
    },
    '& h1': {
      fontWeight: 700,
      color: '#4D5E80',
      fontSize: 32,
      margin: 0
    },
    '& span': {
      color: '#555555',
      fontSize: 16,
      maxWidth: '25%'
    }
  },
  bottomBtns: {
    marginTop: 50,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column-reverse',
      alignItems: 'center',
      '& button': {
        width: '200px !important'
      }
    },
    '& button': {
      width: 150
    }
  },
  cancelBtn: {
    width: 146,
    border: '2px solid #EF7C8F',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    color: '#EF7C8F',
    borderRadius: 8,
    '&:hover': {
      border: '2px solid #EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  sendBtn: {
    backgroundColor: '#386093',
    width: 148,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  steps: {
    marginTop: 40,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    '& p': {
      margin: 0,
      fontWeight: 700,
      fontSize: 16
    },
    '& span': {
      fontWeight: 500,
      fontSize: 14
    }
  },
  contents: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 20
  },
  focus__label: {
    '& circle': {
      stroke: '#868E96'
    },
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    '& h1': {
      color: '#555555',
      fontSize: 16,
      fontWeight: 700
    }
  },
  mobile: {
    position: 'relative',
    height: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    '& .selected': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 40,
      height: 40,
      borderRadius: 50,
      backgroundColor: '#386093'
    }
  },
  mobile__header: {
    '& .padding': {
      height: 20,
      width: '100%',
      position: 'sticky',
      bottom: 0,
      boxShadow: '4px 4px 17px 2px #E7E7E7',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      backgroundColor: '#FFF',
      minHeight: 70,
      borderRadius: '32px 32px 0px 0px'
    }
  },
  mobile__main: {
    '& .title_main': {
      padding: '15px 5px 10px 5px'
    },
    '& .imgSection': {
      position: 'relative',
      objectFit: 'none',
      width: '100%',
      height: 'auto'
    },
    '& .titleContent': {
      display: 'flex',
      fontSize: '12px',
      width: '100%',
      height: 'auto',
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      margin: '0px',
      padding: '0px'
    }
  },
  floatBtn: {
    position: 'absolute',
    bottom: -35,
    right: 8,
    height: 50,
    width: 50,
    borderRadius: 50,
    backgroundColor: '#EF7C8F',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  contentInfo: {
    width: 'fit-content',
    marginTop: 5,
    padding: 8,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    '& p, span': {
      margin: 0
    },
    '& span': {
      color: '#9B9B9B',
      fontSize: 11,
      fontWeight: 500
    },
    '& p': {
      fontWeight: 600,
      fontSize: 11,
      color: '#555555'
    }
  },
  content: {
    marginTop: 0,
    padding: 3,
    '& video': {
      width: '100%'
    },
    '& img': {
      width: '100%'
    },
    '& .abstract': {
      margin: '10px',
      fontSize: 16,
      fontWeight: 700,
      color: '#7B7B7B'
    },
    '& .text_content': {
      margin: 10,
      fontSize: 13,
      color: '#7B7B7B',
      fontWeight: 500,
      '& iframe': {
        width: '100% !important',
        aspectRatio: '16 / 9',
        height: 'auto !important',
        display: 'block',
        margin: '0 auto'
      }
    }
  },
  mobile__header__top: {
    position: 'sticky',
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    backgroundColor: theme.palette.primary.main,
    height: 20,
    minHeight: 31.5,
    width: '100%',
    borderRadius: '32px 32px 0px 0px',
    zIndex: '9',
    '& .mobile_header_top_svg': {
      width: '100%',
      height: '100%'
    }
  },
  mobile__footer: {
    position: 'sticky',
    bottom: 0,
    boxShadow: '4px 4px 17px 2px #E7E7E7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    backgroundColor: '#FFF',
    height: 20,
    minHeight: 70,
    width: '100%',
    borderRadius: '32px 32px 0px 0px'
  },
  mobile__headbar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .title': {
      margin: 0,
      fontSize: 13,
      fontWeight: 600,
      padding: '5px',
      color: '#386093'
    }
  },
  relationship: {
    width: '100%',
    [theme.breakpoints.down('500')]: {
      width: '100%'
    },
    [theme.breakpoints.down('1800')]: {
      width: '100%'
    },
    borderRadius: '8px !important',
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    border: `1px solid  rgb(173, 184, 204)`,
    outline: 'none !important',
    padding: '8px !important',
    '& svg': {
      marginRight: '5px',
      color: `${theme.palette.primary.dark}`
    }
  },
  hover: {
    '& div:first-child:hover': {
      borderColor: `${theme.palette.primary.light}`
    }
  },
  imgModule: {
    '& img': {
      objectFit: 'fill'
    }
  },
  mobile__header__title: {
    position: 'sticky',
    top: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: '#fff',
    height: 20,
    minHeight: 62,
    width: '100%',
    borderRadius: '32px 32px 0px 0px',
    zIndex: '9',
    '& .mobile_header_title_svg': {
      backgroundColor: theme.palette.primary.main,
      paddingBottom: '4px'
    },
    '& .mobile_header_title_svg_icon': {
      width: '100%',
      height: '100%'
    },
    '& .title': {
      margin: 0,
      fontSize: 13,
      fontWeight: 600,
      padding: '5px',
      color: theme.palette.primary.main
    }
  },
  mobile__header__arow_back: {
    display: 'flex',
    backgroundColor: '#fff',
    '& .mobile_header_arow': {
      paddingLeft: '15px',
      cursor: 'pointer'
    },
    '& .mobile_header_icon': {
      paddingTop: '5px',
      fontSize: '1.5rem'
    }
  },
  seeThemes: {
    display: 'flex',
    flexDirection: 'column',
    color: theme.palette.primary.main,
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '150%',
    padding: '0px 5px 0px 5px',
    '& img': {
      width: '100%',
      height: '150px',
      marginTop: '90px'
    }
  },
  seeThemes_button: {
    width: 220,
    height: 35,
    padding: '14px 48px',
    gap: 10,
    color: '#fff',
    borderRadius: 8,
    fontWeight: 600,
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: '11px',
    fontStyle: 'normal',
    lineHeight: 'normal'
  },
  steps_home: {
    display: 'flex',
    padding: '15px 5px 15px 5px',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& .steps_home_steps': {
      paddingLeft: '2.1rem'
    },
    '& .steps_home_itens': {
      cursor: 'pointer',
      paddingLeft: '8px'
    },
    '& .steps_home_itens_iten': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      padding: '15px',
      width: '10px',
      height: '10px'
    }
  },
  mobile__content__home: {
    paddingBottom: '25px',
    '& .mobile__content__home_titleIcon': {
      display: 'flex'
    },
    '& .mobile__content__home_icon': {
      margin: '0rem 0.3rem 0.3rem 0.3rem',
      fontSize: '30px',
      color: '#9B9B9B'
    },
    '& .mobile__content__home_title': {
      color: theme.palette.primary.main,
      fontWeight: '700',
      marginRight: '0.8rem',
      marginTop: '5px'
    },
    '& .mobile__content__home_abstract': {
      marginLeft: '2.4rem',
      marginRight: '0.7rem',
      fontSize: 10
    }
  },
  readMore: {
    display: 'flex',
    justifyContent: 'left',
    alignContent: 'center',
    alignItems: 'center',
    width: '100%',
    '& .readMore_title': {
      marginLeft: '1.8rem',
      fontSize: 12,
      padding: '10px',
      color: '#00ACDB',
      cursor: 'pointer',
      fontWeight: '600'
    },
    '& .readMore_icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 172, 219, 0.1)',
      borderRadius: '50%',
      padding: '11px',
      width: '11px',
      height: '11px',
      cursor: 'pointer'
    },
    '& .readMore_icon_svg': {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#00ACDB'
    }
  },
  files: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    padding: '0px 2px 0px 2px',
    border: '1px solid #386093',
    borderRadius: '10px',
    margin: '0px 10px 0px 10px',
    boxSizing: 'border-box',
    '& p': {
      color: '#386093',
      fontFamily: 'Montserrat',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '24px'
    },
    '& .files': {
      display: 'flex',
      alignItems: 'center',
      padding: '3px 3px'
    },
    '& .files_icon_container': {
      width: '40px',
      height: '40px',
      backgroundColor: '#38609326',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },

    '& .files_svg': {
      width: '9px',
      height: '9px'
    }
  },
  titleFiles: {
    backgroundColor: '#ADB8CC',
    padding: '10px 10px 10px 10px'
  }
}))

const ThirdStepThemeForm = props => {
  const {
    history,
    currentStep,
    steps,
    currentTheme,
    contents,
    themeOccupations,
    editThemeRSPA
  } = props
  const classes = useStyles()
  const [confirmModal, setConfirmModal] = React.useState({ open: false })
  const occupationKeys = Object.keys(occupationsObject)
  const firstValidOccupation = themeOccupations.find(occupation =>
    occupationsObject.hasOwnProperty(occupation)
  )
  const ocupationIndex = occupationKeys.indexOf(firstValidOccupation) + 1

  const [focoOccupation, setFocoOccupation] = React.useState(
    firstValidOccupation || ''
  )
  const PRIMARY_COLOR = process.env.REACT_APP_PROJECT_COLOR_PRIMARY
  const [ocupationSelect, setOcupationSelect] = React.useState(ocupationIndex)
  const [isTextOpen, setIsTextOpen] = React.useState(false)
  const [stageSelected, setStageSelected] = React.useState(1)
  const [category, setCategory] = React.useState(0)
  const [hasATheme, setHasATheme] = React.useState(false)
  const customIcon = props => <ArrowDropDownIcon {...props} />
  const handleSelectChange = event => {
    const selectedValue = event.target.value
    const selectedKey = occupationKeys.find(
      key => occupationsObject[key] === selectedValue
    )
    const index = occupationKeys.indexOf(selectedKey) + 1
    const ocuppationFortheme = contents.some(
      occupation => occupation?.occupation_id === index
    )
    setHasATheme(ocuppationFortheme)
    setOcupationSelect(index)
    setFocoOccupation(selectedKey)
    setStageSelected(1)
    if (isTextOpen) {
      setIsTextOpen(false)
    }
  }
  React.useEffect(
    () => {
      setOcupationSelect(ocupationIndex)
      setFocoOccupation(firstValidOccupation || '')
    },
    [ocupationIndex]
  )

  React.useEffect(
    () => {
      if (contents.length === 0) {
        setHasATheme(true)
      } else if (contents[0]?.occupation_id !== 10) {
        setHasATheme(false)
      } else {
        setHasATheme(true)
      }
    },
    [contents]
  )

  const reload = () => {
    if (!Array.isArray(contents)) {
      window.location.reload()
    }
  }
  reload()

  const relationSelect = props => (
    <div className={classes.hover}>
      <Select
        className={classes.relationship}
        disableUnderline
        value={occupationsObject[focoOccupation] || ''}
        IconComponent={customIcon}
        onChange={handleSelectChange}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          getContentAnchorEl: null
        }}
      >
        {themeOccupations.map((occupation, index) => (
          <MenuItem key={index} value={occupationsObject[occupation]}>
            {occupationsObject[occupation]}
          </MenuItem>
        ))}
      </Select>
    </div>
  )

  const fileTypes = {
    image: [
      'jpg',
      'jpeg',
      'png',
      'gif',
      'bmp',
      'svg',
      'webp',
      'tiff',
      'ico',
      'heic',
      'psd',
      'raw',
      'jfif'
    ],
    video: [
      'mp4',
      'avi',
      'mov',
      'mkv',
      'webm',
      'flv',
      'wmv',
      'mpeg',
      'mpg',
      '3gp',
      'm4v'
    ],
    audio: [
      'mp3',
      'wav',
      'aac',
      'flac',
      'ogg',
      'wma',
      'alac',
      'aiff',
      'opus',
      'm4a'
    ],
    document: [
      'pdf',
      'doc',
      'docx',
      'txt',
      'ppt',
      'pptx',
      'xls',
      'xlsx',
      'csv',
      'odt',
      'ods',
      'odp',
      'rtf',
      'html',
      'xml',
      'json',
      'yml',
      'zip',
      'rar',
      '7z',
      'tar',
      'gz',
      'bz2',
      'tgs',
      'tgz'
    ]
  }

  function identifyFileType (filename) {
    const ext = filename
      .replace(/\.$/, '')
      .split('.')
      .pop()
      .toLowerCase()
    for (const [type, extensions] of Object.entries(fileTypes)) {
      if (extensions.includes(ext)) {
        return type
      }
    }
    return 'unknown'
  }

  function truncateFilename (filename, maxLength = 15) {
    const extIndex = filename.lastIndexOf('.')
    if (extIndex === -1) return filename
    const name = filename.substring(0, extIndex)
    const ext = filename.substring(extIndex)
    if (name.length > maxLength) {
      return name.substring(0, maxLength) + '...' + ext
    }
    return filename
  }

  return (
    <div>
      <div className={classes.header}>
        <div className='title'>
          <StyledSVG src={previewSVG} height={32} width={32} />
          <h1>Visualize o conteúdo do tema</h1>
        </div>
        <span>
          Abaixo você consegue visualizar o tema e o conteúdo aplicado.
        </span>
      </div>

      <div className={classes.steps}>
        <FormProgress currentStep={currentStep} steps={steps} />
      </div>
      <Grid item xs={6} sm={2}>
        <h3 style={{ margin: '0 0 10px 0' }}>Foco</h3>
        <Field component={relationSelect} />
      </Grid>
      <MobilePreview>
        {!isTextOpen &&
          hasATheme && (
            <div className={classes.mobile__header__top}>
              <div>
                <StyledSVG className='mobile_header_top_svg' src={frame} />
              </div>
            </div>
          )}
        {isTextOpen && (
          <div className={classes.mobile__header__title}>
            <div className='mobile_header_title_svg'>
              <StyledSVG className='mobile_header_title_svg_icon' src={frame} />
            </div>
            <div className={classes.mobile__header__arow_back}>
              <div className='mobile_header_arow'>
                <ArrowBackIosIcon
                  className='mobile_header_icon'
                  onClick={() => setIsTextOpen(false)}
                />
              </div>
              <div style={{ paddingLeft: '15px' }}>
                <p className='title'>{currentTheme?.title}</p>
              </div>
            </div>
          </div>
        )}
        <div className={classes.mobile}>
          {!isTextOpen &&
            !hasATheme &&
            ocupationSelect && (
              <>
                <Grid>
                  <div className={classes.mobile__header__title}>
                    <div className='mobile_header_title_svg'>
                      <StyledSVG
                        className='mobile_header_title_svg_icon'
                        src={frame}
                      />
                    </div>
                  </div>
                  <div className={classes.seeThemes}>
                    <img src={seethemes} />
                    <p>
                      Ainda não há conteúdo disponível para este tema. Volte
                      mais tarde para conferir novidades.
                    </p>
                    <Button
                      type='button'
                      variant='contained'
                      color='primary'
                      className={classes.seeThemes_button}
                      onClick={() =>
                        history.push(`/newthemes/${currentTheme?.id}/contents`)
                      }
                    >
                      Ver temas
                    </Button>
                  </div>
                </Grid>
              </>
            )}
          {!isTextOpen &&
            hasATheme && (
              <>
                <div className={classes.imgModule}>
                  <img
                    src={currentTheme?.cover?.image_url}
                    width={'100%'}
                    height={'190px'}
                  />
                </div>
                <div className={classes.steps_home}>
                  <p className='steps_home_steps'>Etapas</p>
                  {(() => {
                    const seenStages = new Set()
                    return contents?.map((content, index) => {
                      if (
                        ocupationSelect === content.occupation_id &&
                        content.stage &&
                        !seenStages.has(content.stage)
                      ) {
                        seenStages.add(content.stage)

                        return (
                          <div
                            key={index}
                            onClick={() => setStageSelected(content.stage)}
                            className='steps_home_itens'
                          >
                            <div
                              className='steps_home_itens_iten'
                              style={{
                                backgroundColor:
                                  content.stage === stageSelected
                                    ? PRIMARY_COLOR
                                    : '#F1F3F4'
                              }}
                            >
                              <p
                                style={
                                  content.stage === stageSelected
                                    ? { color: '#fff' }
                                    : { color: '#000' }
                                }
                              >
                                {'0' + content.stage}
                              </p>
                            </div>
                          </div>
                        )
                      }
                      return null
                    })
                  })()}
                </div>
              </>
            )}

          {contents.map((content, index) => {
            return (
              <>
                {!isTextOpen &&
                  stageSelected === content.stage &&
                  content.occupation_id === ocupationSelect && (
                    <Grid className={classes.mobile__content__home} xs={12}>
                      <div className='mobile__content__home_titleIcon'>
                        <MenuBookTwoToneIcon className='mobile__content__home_icon' />
                        <span className='mobile__content__home_title'>
                          {content.title}
                        </span>
                      </div>
                      <p className='mobile__content__home_abstract'>
                        {content.abstract}
                      </p>
                      <div
                        className={classes.readMore}
                        onClick={() => {
                          setIsTextOpen(true)
                          setCategory(content.category_id)
                        }}
                      >
                        <span className='readMore_title'>Leia mais...</span>
                        <div className='readMore_icon'>
                          <ArrowForwardIosIcon className='readMore_icon_svg' />
                        </div>
                      </div>
                    </Grid>
                  )}

                {isTextOpen &&
                  stageSelected === content.stage &&
                  content.occupation_id === ocupationSelect &&
                  content.category_id &&
                  category === content.category_id && (
                    <>
                      <div className={classes.mobile__main}>
                        <div className='titleContent'>
                          <h3 className='title_main'>{content.title}</h3>
                        </div>
                        <div className={classes.content}>
                          <p className='abstract'>{content.abstract}</p>
                          <p
                            className='text_content'
                            dangerouslySetInnerHTML={{
                              __html: content.text_content
                            }}
                          />
                        </div>
                      </div>
                      {content?.document_urls && (
                        <div>
                          <div className={classes.titleFiles}>
                            <h2>Anexos</h2>
                          </div>

                          {content?.document_urls?.map(item => {
                            return (
                              <>
                                <div style={{ paddingTop: '10px' }} />
                                <div className={classes.files} key={item.id}>
                                  <div className='files'>
                                    <div className='files_icon_container'>
                                      {identifyFileType(item.filename) ===
                                        'audio' && (
                                        <StyledSVG
                                          className='files_svg'
                                          src={FileAudio}
                                        />
                                      )}
                                      {identifyFileType(item.filename) ===
                                        'video' && (
                                        <StyledSVG
                                          className='files_svg'
                                          src={FileVideo}
                                        />
                                      )}
                                      {(identifyFileType(item.filename) ===
                                        'document' ||
                                        identifyFileType(item.filename) ===
                                          'image') && (
                                          <StyledSVG
                                            className='files_svg'
                                            src={FileFolder}
                                        />
                                      )}
                                    </div>
                                  </div>

                                  <p>{truncateFilename(item.filename)}</p>
                                </div>
                              </>
                            )
                          })}
                        </div>
                      )}
                      <div style={{ paddingBottom: '23px' }} />
                    </>
                  )}
              </>
            )
          })}
        </div>
      </MobilePreview>
      <Modal
        open={confirmModal.open}
        handleClose={() => setConfirmModal(prev => ({ open: !prev.open }))}
      >
        <div>
          <h1>Atenção!</h1>
          <h2>
            {`Deseja finalizar a criação do tema "${currentTheme?.title}" ?`}
          </h2>
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          <Button
            variant='outlined'
            className={classes.cancelBtn}
            onClick={() => {
              setConfirmModal(prev => ({ open: !prev.open }))
            }}
          >
            Cancelar
          </Button>
          <Button
            className={classes.sendBtn}
            variant='contained'
            onClick={async () => {
              await editThemeRSPA({
                id: currentTheme.id,
                status: 'done'
              })
              history.push('/newthemes')
            }}
          >
            Concluir
          </Button>
        </div>
      </Modal>
      <div className={classes.bottomBtns}>
        <Button
          type='button'
          variant={'outlined'}
          className={classes.cancelBtn}
          onClick={() =>
            history.push(`/newthemes/${currentTheme?.id}/contents`)
          }
        >
          Voltar
        </Button>
        <Button
          onClick={() => setConfirmModal(prev => ({ open: true }))}
          className={classes.sendBtn}
        >
          {'Próximo'}
        </Button>
      </div>
    </div>
  )
}

export default ThirdStepThemeForm
